import { render, staticRenderFns } from "./LayoutRouterView.vue?vue&type=template&id=1801b4da&"
import script from "./LayoutRouterView.vue?vue&type=script&lang=js&"
export * from "./LayoutRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports